import { useQuery } from '@tanstack/react-query'
import { getWarrantyService } from 'redux/services/productsServices'
import { QUERY_KEYS } from 'Utils/queryKeys'

export const useWarrantyTypes = () =>
  useQuery({
    queryKey: [QUERY_KEYS.WARRANTY_TYPES],
    queryFn: async () => {
      const response = await getWarrantyService()
      if (response?.data?.Data) return response.data.Data
      throw new Error('Could not retrieve the warranties')
    },
    staleTime: 1000 * 60 * 60 * 15,
    cacheTime: 1000 * 60 * 60 * 15,
    refetchOnWindowFocus: false,
  })
